<script lang="ts">
  import { push } from 'svelte-spa-router';

  const editorModes = [
    {
      path: '/edit/wordbanks',
      title: 'Edit Wordbanks',
      description: 'Manage word lists for slot types (adjective, noun, verb, etc.)',
      icon: '📝',
    },
    {
      path: '/edit/prompts',
      title: 'Edit Prompts',
      description: 'Manage prompts for each category (thing, story, person, place)',
      icon: '💡',
    },
    {
      path: '/edit/frameworks',
      title: 'Edit Frameworks',
      description: 'Manage clue templates with slot placeholders',
      icon: '🏗️',
    },
  ];

  function navigateTo(path: string) {
    push(path);
  }
</script>

<div class="editor-home">
  <div class="home-header">
    <h1>What would you like to edit?</h1>
    <p>Choose a content type to start editing</p>
  </div>

  <div class="mode-cards">
    {#each editorModes as mode}
      <button
        class="mode-card"
        on:click={() => navigateTo(mode.path)}
        aria-label={mode.title}
      >
        <span class="mode-icon" aria-hidden="true">{mode.icon}</span>
        <h2>{mode.title}</h2>
        <p>{mode.description}</p>
      </button>
    {/each}
  </div>

  <div class="home-footer">
    <a href="#/" class="back-link">← Back to Game</a>
  </div>
</div>

<style>
  .editor-home {
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem;
  }

  .home-header {
    text-align: center;
    margin-bottom: 3rem;
  }

  .home-header h1 {
    margin: 0 0 0.5rem 0;
    font-size: 2rem;
    color: var(--color-text-primary, #333);
  }

  .home-header p {
    margin: 0;
    color: var(--color-text-secondary, #666);
    font-size: 1.125rem;
  }

  .mode-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 1.5rem;
    margin-bottom: 3rem;
  }

  .mode-card {
    background: white;
    border: 2px solid var(--color-border, #ddd);
    border-radius: 8px;
    padding: 2rem;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s;
    text-decoration: none;
  }

  .mode-card:hover {
    border-color: var(--color-primary, #007bff);
    box-shadow: 0 4px 12px rgba(0, 123, 255, 0.15);
    transform: translateY(-4px);
  }

  .mode-card:focus {
    outline: 3px solid var(--color-focus, #007bff);
    outline-offset: 2px;
  }

  .mode-icon {
    font-size: 3rem;
    display: block;
    margin-bottom: 1rem;
  }

  .mode-card h2 {
    margin: 0 0 0.75rem 0;
    font-size: 1.5rem;
    color: var(--color-text-primary, #333);
  }

  .mode-card p {
    margin: 0;
    color: var(--color-text-secondary, #666);
    line-height: 1.5;
  }

  .home-footer {
    text-align: center;
  }

  .back-link {
    color: var(--color-primary, #007bff);
    text-decoration: none;
    font-weight: 500;
  }

  .back-link:hover {
    text-decoration: underline;
  }

  .back-link:focus {
    outline: 3px solid var(--color-focus, #007bff);
    outline-offset: 2px;
  }
</style>
